export const CREATE_FIRM_MUTATION = `
  mutation CreateFirm($object: firms_insert_input!) {
    insert_firms_one(object: $object) {
      id
      company_id
      firm_name
      firm_short_name
      firm_city
      firm_references
      description
      luca_code
      is_established
      partner_referral
      reference_type
      reference_firm_id
      reference_text
      created_at
      updated_at
      company {
        id
        name
      }
      reference_firm {
        id
        firm_name
        firm_short_name
      }
      firm_partners {
        id
        partner_id
        partner {
          id
          partner_name
        }
      }
      firm_sectors {
        id
        sector_id
        sector {
          id
          sector_name
        }
      }
    }
  }
`;

export const UPDATE_FIRM_MUTATION = `
  mutation UpdateFirm($id: Int!, $set: firms_set_input!) {
    update_firms_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      company_id
      firm_name
      firm_short_name
      firm_city
      firm_references
      description
      luca_code
      is_established
      partner_referral
      reference_type
      reference_firm_id
      reference_text
      created_at
      updated_at
      company {
        id
        name
      }
      reference_firm {
        id
        firm_name
        firm_short_name
      }
      firm_partners {
        id
        partner_id
        partner {
          id
          partner_name
        }
      }
      firm_sectors {
        id
        sector_id
        sector {
          id
          sector_name
        }
      }
    }
  }
`;

export const DELETE_FIRM_MUTATION = `
  mutation DeleteFirm($id: Int!) {
    delete_firms_by_pk(id: $id) {
      id
      firm_name
    }
  }
`;

// Mutations for managing firm-partner relationships
export const CREATE_FIRM_PARTNER_MUTATION = `
  mutation CreateFirmPartner($object: firm_partners_insert_input!) {
    insert_firm_partners_one(object: $object) {
      id
      firm_id
      partner_id
      partner {
        id
        partner_name
      }
    }
  }
`;

export const DELETE_FIRM_PARTNER_MUTATION = `
  mutation DeleteFirmPartner($id: Int!) {
    delete_firm_partners_by_pk(id: $id) {
      id
    }
  }
`;

// Mutations for managing firm-sector relationships
export const CREATE_FIRM_SECTOR_MUTATION = `
  mutation CreateFirmSector($object: firm_sectors_insert_input!) {
    insert_firm_sectors_one(object: $object) {
      id
      firm_id
      sector_id
      sector {
        id
        sector_name
      }
    }
  }
`;

export const DELETE_FIRM_SECTOR_MUTATION = `
  mutation DeleteFirmSector($id: Int!) {
    delete_firm_sectors_by_pk(id: $id) {
      id
    }
  }
`; 